export default {
  pagination: {},
  offer: null,
  offers: [],
  orderBumpOffers: []
};
